import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const DownloadFilled: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58173 12.4183 0 8 0C3.58173 0 0 3.58173 0 8C0 12.4183 3.58173 16 8 16ZM8 3.42857C8.63118 3.42857 9.14286 3.94025 9.14286 4.57143V8.57143H10.8572C11.0883 8.57143 11.2966 8.71065 11.3851 8.92418C11.4735 9.13771 11.4247 9.38349 11.2612 9.54691L8.40408 12.4041C8.18093 12.6272 7.81911 12.6272 7.59595 12.4041L4.73881 9.54691C4.57538 9.38349 4.52649 9.13771 4.61494 8.92418C4.70339 8.71065 4.91175 8.57143 5.14287 8.57143H6.85714V4.57143C6.85714 3.94025 7.36882 3.42857 8 3.42857Z"
      fill="currentColor"
    />
  </svg>
);
